import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {
    WB_UIProfileRow,
} from "../PA.Core/PAdbSchemaRows";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {
    esWB_UI_Profile
} from "../PA.Core/PAdbSchema";
import {ASync} from "../PA.Core/Basic/ASync";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import _ = require('lodash');
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {RecordUtils} from "../PA.Core/Basic/Records";


export class UIProfileBO implements IBusinessObject {

    Identity: IdentityProvider;


    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_UIProfile: WB_UIProfileRow;

    dctAuditedDeletes: {[id:number]: number}
    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Profile'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_UIProfile = undefined;

    }

    get WB_UIProfile(): WB_UIProfileRow {
        return this.drWB_UIProfile;
    }


    //<editor-fold desc = "IBusinessObject operations">


    async Copy(options?: any): Promise<IBusinessObject> {
        const self = this

        const src: UIProfileBO = this;

        const tgt = new UIProfileBO({});
        await tgt.LoadNew()

        if (!tgt.bIsLoaded)
            throw new Error("Unable to create New Profile")

        RecordUtils.CopyProperties(tgt.dbContext, esWB_UI_Profile,
            src.WB_UIProfile, tgt.WB_UIProfile,
            [],
            ['DELETED_DT', 'DELETED_IND'],
            {})

        tgt.WB_UIProfile.cif.PROFILE_ID =src.WB_UIProfile.cif.PROFILE_ID  + "_Copy"
        tgt.WB_UIProfile.cif.PROFILE_NAME = src.WB_UIProfile.cif.PROFILE_NAME  + "_Copy"
        tgt.Identity.setAll(tgt.WB_UIProfile.cif.WB_UI_PROFILE_ID, tgt.WB_UIProfile.cif.PROFILE_ID, tgt.WB_UIProfile.cif.PROFILE_NAME);

        return tgt
    }

    LoadNew(options?: any): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Profile");

        let internalOnComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext )) {
                var sError = "Unable to determine dbContext for new profile.";
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_UI_Profile)
                .then((newProfile: WB_UIProfileRow) => {
                    newProfile.setDefaults()
                    self.drWB_UIProfile = newProfile;
                    self.drWB_UIProfile.cif.PROFILE_NAME = "New Profile"
                    self.dbContext.add(esWB_UI_Profile, newProfile)
                    self.Identity.setAll(self.WB_UIProfile.cif.WB_UI_PROFILE_ID, self.WB_UIProfile.cif.PROFILE_ID, self.WB_UIProfile.cif.PROFILE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_UIProfile, 'WB_UI_PROFILE_ID', 'PROFILE_ID', 'PROFILE_NAME')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        self._OnLoadComplete = internalOnComplete

        return new Promise<IBusinessObject>((resolve, error) => {
            internalOnComplete
                .then((BO) => {
                    return ASync.resolve()
                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()
                resolve(self)
            }).catch((err) => {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
            })
        })
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Profile already loaded.")
                resolve(self); // "Profile already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, {})


            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext )) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext )) {
                error("Unable to determine dbContext for Profile.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = UIProfileBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = UIProfileBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aProfileRow: any = recordResolver.get(esWB_UI_Profile, anId)

                    if (_.isEmpty(aProfileRow)) {
                        error("Profile not Found");
                        return;
                    }

                    self.drWB_UIProfile = aProfileRow;
                    self.Identity.setAll(self.WB_UIProfile.cif.WB_UI_PROFILE_ID, self.WB_UIProfile.cif.PROFILE_ID, self.WB_UIProfile.cif.PROFILE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_UIProfile, 'WB_UI_PROFILE_ID', 'PROFILE_ID', 'PROFILE_NAME')
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                }).catch(function (err: any) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
                return;
            });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_UIProfile.cif.PROFILE_NAME + "(" + self.WB_UIProfile.cif.PROFILE_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate Profile.";
                self._bIsValidated = false;
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
                return
            }

         //   UIProfileBOValidations.Validate(self)
         //       .then((ignore) => {
                    self._bIsValidated = true;
                    self.ValidateProgressProvider.finish();
                    resolve(self);
       //         })
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }


    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        var self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_UIProfile.cif.PROFILE_NAME + "(" +  self.WB_UIProfile.cif.PROFILE_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (self.dbContext == undefined) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Profile.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};
            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let bDone = false
            self.Validate({})
                .then((ignore) => {
                    if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        self._bIsSaved = false;
                        self.SaveProgressProvider.finish();
                        bDone = true
                        resolve(self);
                        return
                    }
                })
                .then(() => {
                    return saveFunction(esWB_UI_Profile, self.drWB_UIProfile, {})
                })
                .then((ignored) => {
                    if (bDone) return
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                             })
                    } else {
                        self._bIsSaved = true;
                       }
                    self.SaveProgressProvider.finish();
                })
                .then((ignored) => {
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })

        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete------------------------------------------------------------------------
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.WB_UIProfile.cif.PROFILE_NAME + "(" + self.WB_UIProfile.cif.PROFILE_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Profile

            // 2. If Valid, mark all the records for deletion.
            self.drWB_UIProfile.markDeleted()

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver Operations">

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_UI_Profile, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {
                [esWB_UI_Profile]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass( UIProfileBO, "UIProfileBO" ,"UI Profile")